export default "__VITE_ASSET__763ffa0f__"